import i18n from "i18next";
import Backend from "i18next-xhr-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { hyMap } from "./lang/hy";
import { enMap } from "./lang/en";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "hy",
    debug: true,
    resources: {
      en: {
        translation: enMap,
      },
      hy: {
        translation: hyMap,
      },
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
